import { startRegistration } from "@simplewebauthn/browser";
import apiClient from "../services/api";

// Full WebAuthn registration ceremony for the signed-in user. Resolves on success, throws on cancel/failure.
export const registerPasskey = async () => {
  const { options } = (await apiClient.post(`/passkeys/registration-options`)).data;
  const credential = await startRegistration({ optionsJSON: options });
  if (!credential) throw new Error("Passkey creation was cancelled");
  const verifyRes = await apiClient.post(`/passkeys/registration-verify`, {
    id: credential.id,
    rawId: credential.rawId,
    response: {
      clientDataJSON: credential.response.clientDataJSON,
      attestationObject: credential.response.attestationObject,
      transports: credential.response.getTransports?.() || ["internal"],
    },
    type: credential.type,
    clientExtensionResults: credential.clientExtensionResults,
    authenticatorAttachment: credential.authenticatorAttachment,
  });
  if (!verifyRes.data.verified) throw new Error("Verification failed");
  return verifyRes.data;
};

export const passkeyErrorMessage = (err) => {
  if (err.name === "NotAllowedError") return "Passkey setup was cancelled";
  if (err.name === "InvalidStateError") return "A passkey already exists on this device";
  return err.response?.data?.detail || err.message || "Failed to register passkey";
};

export const formatPasskeyDate = (dateStr) => {
  if (!dateStr) return "Never";
  try {
    return new Date(dateStr).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return dateStr;
  }
};
